// Angular
import { NgModule } from '@angular/core';

// NgRx
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { UserModule } from '@core/state/user/user.module';

// Core Protocol
import {
  IntranetCoreProtocolModule,
  NgrxRouterModule,
} from '@tech/intranet-core-protocol';

// Environment
import { environment } from '@environments/environment';

// Routing
import { CoreRoutes } from '@core/config/core-routes';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forRoot({}),
    EffectsModule.forRoot(),
    StoreDevtoolsModule.instrument({
      name: 'Tech Architecture Store',
      logOnly: environment.production,
      maxAge: 25,
    }),
    IntranetCoreProtocolModule.forRoot({
      coreRoutes: CoreRoutes,
      coreOrigin: environment.coreOrigin,
      moduleOrigin: environment.moduleOrigin,
      moduleCode: environment.moduleCode,
      disableProtocol: false,
    }),
    NgrxRouterModule,
    UserModule,
  ],
  exports: [NgrxRouterModule],
})
export class NgRxModule {}
